<template>
  <div class="stepModal position-relative">
    <div class="modal fade" id="pluginCommentModal" data-keyboard="false" data-backdrop="static" tabindex="-1" role="dialog" aria-labelledby="pluginCommentModal">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" v-if="plugin" id="pluginCommentModalHeader">
              <i class="fa fa-comment mr-2"></i>
              {{ plugin.comment ? 'Edit' : 'Add' }} Comment for {{ plugin.title || plugin.name }}
            </h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">&times;</span>
            </button>
          </div>
          <div v-if="loading" class="loader"></div>
          <div v-else class="modal-body">
            <div class="row">
              <div class="col-md-12">
                <form @submit.prevent="saveComment">
                  <div class="form-group">
                    <label class="font-weight-bold">Comment:</label>
                    <textarea 
                      class="form-control" 
                      required 
                      rows="4" 
                      v-model="commentText"
                      placeholder="Enter your comment..."
                      style="resize: vertical;"
                    ></textarea>
                    <small class="form-text text-muted">
                      Add notes, observations, or recommendations.
                    </small>
                  </div>
                  <div class="d-flex justify-content-between align-items-center">
                    <div v-if="plugin.comment" class="text-muted small">
                      <i class="fa fa-info-circle mr-1"></i>
                      Last updated by: {{ plugin.comment.addedBy }}
                    </div>
                    <div>
                      <button 
                        type="button" 
                        class="btn btn-secondary mr-2" 
                        @click="closeModal"
                      >
                        Cancel
                      </button>
                      <button 
                        class="btn btn-primary" 
                        type="submit"
                        :disabled="!commentText || !commentText.trim()"
                      >
                        <i class="fa fa-save mr-1"></i>
                        {{ plugin.comment ? 'Update' : 'Save' }} Comment
                      </button>
                    </div>
                  </div>
                </form>
              </div>
            </div>
            <div v-if="plugin.comment && plugin.comment.text" class="mt-4">
              <hr>
              <div class="card bg-light">
                <div class="card-body">
                  <h6 class="card-title">
                    <i class="fa fa-comment-o mr-2"></i>
                    Current Comment
                  </h6>
                  <p class="card-text mb-2" v-html="plugin.comment.text"></p>
                  <div class="d-flex justify-content-between align-items-center mt-3">
                    <small class="text-muted">
                      <i class="fa fa-user mr-1"></i>
                      {{ plugin.comment.addedBy }}
                    </small>
                    <button 
                      class="btn btn-sm btn-danger" 
                      @click="deleteComment"
                      type="button"
                    >
                      <i class="fa fa-trash mr-1"></i>
                      Delete Comment
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {db} from "@/firebase/init"
export default {
  name: "PluginCommentModal",
  data () {
    return {
      commentText: '',
      plugin: null,
      docId: null,
      wpoData: null,
      loading: false
    }
  },
  computed: {
    user() {
      return this.$store.getters.user;
    },
    userEmailHash() {
      return this.$store.getters.emailHashGravatar;
    }
  },
  methods: {
    load (plugin, docId, wpoData) {
      this.plugin = plugin
      this.docId = docId
      this.wpoData = wpoData
      
      // Load existing comment if available
      if (this.plugin.comment && this.plugin.comment.text) {
        // Convert HTML back to plain text for editing
        const tmp = document.createElement('DIV');
        tmp.innerHTML = this.plugin.comment.text;
        this.commentText = tmp.textContent || tmp.innerText || '';
      } else {
        this.commentText = '';
      }
      
      $('#pluginCommentModal').modal('show');
      $('.modal-backdrop').removeClass("modal-backdrop");
    },
    async saveComment () {
      if (!this.commentText || !this.commentText.trim()) {
        return;
      }
      
      this.loading = true
      try {
        // Convert newlines to HTML breaks
        const commentHtml = this.commentText.replace(/\n/g, '<br>')
        
        const commentObject = {
          text: commentHtml,
          email: this.user.email,
          addedBy: this.user.firstName + ' ' + this.user.lastName,
          addedByEmailHash: this.userEmailHash,
          updatedAt: new Date().toISOString()
        }
        
        // Update the comment directly on the plugin object
        this.$set(this.plugin, 'comment', commentObject)
        
        // Update the item in the wpoData array (plugins or themes)
        // Check plugins first
        if (this.wpoData.wpo_data.domains[0].plugins) {
          const pluginIndex = this.wpoData.wpo_data.domains[0].plugins.findIndex(p => 
            p.name === this.plugin.name || (p.title && p.title === this.plugin.title)
          )
          if (pluginIndex !== -1) {
            this.wpoData.wpo_data.domains[0].plugins[pluginIndex].comment = commentObject
          }
        }
        // Check themes
        if (this.wpoData.wpo_data.domains[0].themes) {
          const themeIndex = this.wpoData.wpo_data.domains[0].themes.findIndex(t => 
            t.name === this.plugin.name || (t.title && t.title === this.plugin.title)
          )
          if (themeIndex !== -1) {
            this.wpoData.wpo_data.domains[0].themes[themeIndex].comment = commentObject
          }
        }
        
        // Save to Firestore by updating reportData
        await this.updateWpoData()
        
        // Emit event to parent to refresh
        this.$emit('comment-updated', this.wpoData)
        
        this.closeModal()
      } catch (error) {
        console.error('Error saving plugin comment:', error)
        alert('Failed to save comment. Please try again.')
      } finally {
        this.loading = false
      }
    },
    async updateWpoData () {
      // Get the current report data
      const reportDoc = await db.collection('performance-report').doc(this.docId).get()
      const reportData = reportDoc.data().reportData
      
      // Find and update the wpo data in reportData
      const wpoIndex = reportData.findIndex(item => item.type === 'wpo')
      if (wpoIndex !== -1) {
        reportData[wpoIndex] = this.wpoData
      }
      
      // Update Firestore
      await db.collection('performance-report').doc(this.docId).update({
        reportData: reportData,
        modified: new Date().toISOString()
      })
    },
    async deleteComment () {
      if (!confirm('Are you sure you want to delete this comment?')) {
        return;
      }
      
      this.loading = true
      try {
        // Remove the comment from the plugin object
        this.$delete(this.plugin, 'comment')
        
        // Update the item in the wpoData array (plugins or themes)
        // Check plugins first
        if (this.wpoData.wpo_data.domains[0].plugins) {
          const pluginIndex = this.wpoData.wpo_data.domains[0].plugins.findIndex(p => 
            p.name === this.plugin.name || (p.title && p.title === this.plugin.title)
          )
          if (pluginIndex !== -1) {
            this.$delete(this.wpoData.wpo_data.domains[0].plugins[pluginIndex], 'comment')
          }
        }
        // Check themes
        if (this.wpoData.wpo_data.domains[0].themes) {
          const themeIndex = this.wpoData.wpo_data.domains[0].themes.findIndex(t => 
            t.name === this.plugin.name || (t.title && t.title === this.plugin.title)
          )
          if (themeIndex !== -1) {
            this.$delete(this.wpoData.wpo_data.domains[0].themes[themeIndex], 'comment')
          }
        }
        
        // Save to Firestore
        await this.updateWpoData()
        
        // Emit event to parent to refresh
        this.$emit('comment-updated', this.wpoData)
        
        this.commentText = ''
        this.closeModal()
      } catch (error) {
        console.error('Error deleting plugin comment:', error)
        alert('Failed to delete comment. Please try again.')
      } finally {
        this.loading = false
      }
    },
    closeModal() {
      this.commentText = ''
      $('#pluginCommentModal').modal('hide')
    }
  }
}
</script>

<style scoped>
.modal-header {
  background-color: #f8f9fa;
  border-bottom: 1px solid #dee2e6;
}

.modal-title {
  color: #1f4bf1;
  font-weight: 600;
}

.form-control:focus {
  border-color: #1f4bf1;
  box-shadow: 0 0 0 0.2rem rgba(31, 75, 241, 0.25);
}

.btn-primary {
  background-color: #1f4bf1;
  border-color: #1f4bf1;
}

.btn-primary:hover {
  background-color: #3b82f6;
  border-color: #3b82f6;
}

.card {
  border: 1px solid #dee2e6;
}

.card-title {
  color: #495057;
  font-weight: 600;
}
</style>

